import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const IdealHome: Site = {
  id: 'idealhome',
  logo: 'svg/idealhome.svg',
  label: 'Ideal Home',
  analyticsName: 'idealhome',
  hostname: 'idealhome.co.uk',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
